import {Classes} from "@blueprintjs/core";
import * as React from "react";

type DrawerBodyProps = React.PropsWithChildren<{}>;

export const DrawerBody: React.FC<DrawerBodyProps> = ({children}) => (
    <div className={Classes.DRAWER_BODY}>
        <div className={Classes.DIALOG_BODY}>{children}</div>
    </div>
);
